import { render, staticRenderFns } from "./TraderTag.vue?vue&type=template&id=65449f88&scoped=true&"
import script from "./TraderTag.vue?vue&type=script&lang=js&"
export * from "./TraderTag.vue?vue&type=script&lang=js&"
import style0 from "../../styles/button.less?vue&type=style&index=0&id=65449f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65449f88",
  null
  
)

export default component.exports